module.exports = __webpack_public_path__ + "static/media/cohere_template_example.6d62be2b.pdf";